import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Logger } from 'src/app/api/helper/app-error-logger';
import { AuftragsKomponente } from 'src/app/api/model/swagger-model';
import { Auftragdetails } from '../auftragdetails.helper';
import { KomponenteBase } from './komponente';
import { LieferungComponent } from 'src/app/shared/components/lieferung/lieferung.component';

const log = new Logger("AuftragLieferungComponent");

@Component({
    selector: 'auftrag-lieferung-komponente',
    templateUrl: 'lieferung-komponente.component.html',
    styleUrls: ['./lieferung-komponente.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AuftragLieferungComponent extends KomponenteBase implements OnInit {
    @ViewChild('appLieferung', { static: false }) appLieferung: LieferungComponent;

    @Input() auftragdetails: Auftragdetails;
    @Input() komponente: AuftragsKomponente;

    lieferungFormularkonfiguration: AuftragsKomponente;

    isPositionenEinzelnBearbeiten = false;
    isArtikelHinzufuegenButtonAnzeigen = false;

    constructor(
        private router: Router,
        protected cdr: ChangeDetectorRef) {
        super(cdr);
    }

    ngOnInit() {
        log?.debug('ngOnInit');

        this.lieferungFormularkonfiguration = this.auftragdetails?.formularKonfiguration?.komponenten?.find(p => p.name === 'Lieferung');

        this.isPositionenEinzelnBearbeiten = this.getBoolEinstellung('PositionenEinzelnBearbeiten');
        this.isArtikelHinzufuegenButtonAnzeigen = this.getBoolEinstellung('ArtikelHinzufuegenButtonAnzeigen');

        super.ngOnInit();
    }

    async onLieferungClicked(e: TouchEvent) {
        log?.debug('onLieferungClicked', e);

        if (this.isPositionenEinzelnBearbeiten) {
            // Abbruch. Die Positionen werden einzeln bearbeitet. Es sollen nicht alle alle Positionen in einem Popup angezeigt werden.
            // Das ist vorallem auf Tablets mit wenigen Positionen angenehmer. Insbesondere wenn Positionen verwogen werden sollen. (z.B. OFK)
            return;
        }

        if (e.target) {
            const element = e.target as HTMLElement;

            if (element.tagName && element.tagName.toUpperCase() == "ION-BUTTON") {
                // Ignorieren. Es wurde auf einen Plus/Minus-Button geklickt
                return;
            }
        }

        this.auftragdetails.lieferungAendern();
    }

    /**
     * Position hinzufügen.
     */
    async onPositionHinzufuegen() {
        const ok = await this.auftragdetails.onPositionHinzufuegen();

        if (!ok) {
            // Abbruch
            return;
        }

        this.cdr.detectChanges();

        this.appLieferung?.refresh();
    }
}
